export default __webpack_public_path__ + "static/media/Slide18.647ebd74.jpg";